<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <modal-layout modal-name="upload-kosiwon-modal" :width="getSize">
    <h1 slot="header">고시원 올리기 신청</h1>
    <div slot="contents" class="contents">
      <ul>
        <li class="flex align-center">
          <label>고시원 이름</label>
          <input type="text" placeholder="고시원 이름을 입력해 주십시오." v-model="uploadData.kosiwon_name"/>
        </li>
        <li class="flex align-center">
          <label>고시원 전화번호</label>
          <input type="text" placeholder="고시원 전화번호를 입력해 주십시오." v-model="uploadData.kosiwon_phone_number"/>
        </li>
        <li class="flex align-center">
          <label>원장님 전화번호</label>
          <input type="text" placeholder="원장님 전화번호를 입력해 주십시오." v-model="uploadData.manager_phone_number"/>
        </li>
      </ul>
      <p>신청해주시면 연락 후 고시원 등록 진행 도와드리겠습니다.</p>
    </div>
    <div slot="footer" class="edit-footer" @click="uploadKosiwonInfo">
      <button>신청 완료</button>
    </div>
  </modal-layout>
</template>

<script>
  import ModalLayout from '../Layout/ModalLayout'
  import Utils from '../../utils/Utils'
  import Notifications from '../../utils/Notifications'
  export default {
    name: 'UploadKosiwonModal',
    components: {ModalLayout},
    data () {
      return {
        uploadData: {
          kosiwon_name: '',
          kosiwon_phone_number: '',
          manager_phone_number: ''
        }
      }
    },
    computed: {
      getSize () {
        console.log()
        // console.log(this.$mq !== 'sm' ? 600: '100%')
        return Utils.isSmallScreen() ? '100%' : 600
      }
    },
    methods: {
      async uploadKosiwonInfo () {
        if (!this.uploadData.kosiwon_name) {
          Notifications.alert('고시원 이름을 입력해 주십시오.')
          return
        } else if (!this.uploadData.kosiwon_phone_number) {
          Notifications.alert('고시원 전화번호를 입력해 주십시오.')
          return
        } else if (!this.uploadData.manager_phone_number) {
          Notifications.alert('원장님 전화번호를 입력해 주십시오.')
          return
        }

        try {
          const uploadResult = await this.axios.post('/kosiwons/uploadInfoProposal', {
            ...this.uploadData,
          })
          const result = uploadResult.data.result

          if (result) {
            Notifications.alert('요청 주셔서 감사합니다.\n담당자 확인후 빠른 시일내로 연락 드리도록 하겠습니다.\n고시락을 이용해 주셔서 감사합니다.')
            this.uploadData = {
              kosiwon_name: '',
              kosiwon_phone_number: '',
              manager_phone_number: ''
            }
            this.$modal.hide('upload-kosiwon-modal')
          }

        } catch (error) {
          Notifications.alert('등록 도중 오류가 발생하였습니다. 잠시 후 다시 시도해 주시기 바랍니다.')
        }
      }

    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";
  .contents {
    li {
      padding-bottom: 1.2rem;
      color: @black-two;
      /*padding: 0 4rem;*/
      label {
        display: inline-block;
        flex: 1;
        font-weight: bold;
      }
      input {
        box-sizing: border-box;
        min-height: 5rem;
        /*max-width: 80%;*/
        border: 1px solid #d6d6d6;
        padding: 1rem;
        flex: 2;
      }

      textarea {
        min-height: 27rem;
      }
    }
    p {
      text-align: center;
      padding: 2.8rem 0 3.4rem;
      color: @black-two;
    }
  }
  .edit-footer {
    /*padding: 1.5rem 4rem 0;*/
    button {
      height: 50px;
      background-color: @windows-blue;
      width: 100%;
      color: white;
    }
  }
</style>

<style lang="less" scoped>
  @import "../../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    .contents {
      li {
        padding-bottom: 1.2rem;
        /*padding: 0 4rem;*/
        label {
          flex: 1.1;
          font-size: 1.4rem;
        }
        input {
          min-height: 3rem;
          padding: 1.5rem;
          font-size: 1.4rem;
        }
      }
      p {
        font-size: 1.4rem;
        padding: 1.8rem 0 2.4rem;
      }
    }
  }
</style>
